import { HttpErrorResponse } from '@angular/common/http';
import { ApiEnvelope } from '../models/auth.dto';

export function extractErrorMessage(err: HttpErrorResponse, fallback: string): string {
  const body = err.error as ApiEnvelope<unknown> | undefined;
  return body?.message ?? fallback;
}

/**
 * The same extraction, for a request made with `responseType: 'blob'` (file downloads) — on an
 * error response Angular still delivers the body as a `Blob`, not the parsed envelope, so the
 * message has to be read out of it asynchronously before it can be shown.
 */
export async function extractBlobErrorMessage(err: HttpErrorResponse, fallback: string): Promise<string> {
  if (!(err.error instanceof Blob)) {
    return extractErrorMessage(err, fallback);
  }
  try {
    const text = await err.error.text();
    const body = JSON.parse(text) as ApiEnvelope<unknown>;
    return body.message ?? fallback;
  } catch {
    return fallback;
  }
}
